import { render } from "./TestReportSkinSmg.vue?vue&type=template&id=9d774d42&scoped=true&ts=true"
import script from "./TestReportSkinSmg.vue?vue&type=script&lang=ts"
export * from "./TestReportSkinSmg.vue?vue&type=script&lang=ts"

import "./TestReportSkinSmg.vue?vue&type=style&index=0&id=9d774d42&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d774d42"]])

export default __exports__